import { isSameDay, type Currency, type CurrencyAmounts } from '@shared/utils';
import type { Timezone } from 'next-intl';
import { sortByDrawingDateDesc } from './sort';

type WithJackpot = { jackpot: { regular: CurrencyAmounts } };
type WithPrice = { price?: CurrencyAmounts };
type WithDrawingDate = { drawingDate: number | string };

const HUGE_JACKPOT_THRESHOLD = 100; // Millions
const FALLBACK_ITEMS_COUNT = 3;
const PRICE_THRESHOLD = 100;

function isHugeJackpot(jackpot: number): boolean {
  return jackpot > HUGE_JACKPOT_THRESHOLD;
}

function filterHugeJackpots<T extends WithJackpot>(data: T[], currency: Currency): T[] {
  const hugeJackpots = data.filter(({ jackpot }) => isHugeJackpot(jackpot.regular[currency]!)).toSorted((aa, bb) => bb.jackpot.regular[currency]! - aa.jackpot.regular[currency]!);

  return hugeJackpots.length > 0 ? hugeJackpots : data.toSorted((aa, bb) => bb.jackpot.regular[currency]! - aa.jackpot.regular[currency]!).slice(0, FALLBACK_ITEMS_COUNT);
}

function filterOneOrLess<T extends WithPrice>(data: T[], currency: Currency): T[] {
  return data.filter(({ price }) => price && price[currency] && price[currency] <= PRICE_THRESHOLD);
}

function filterTodaysDraws<T extends WithDrawingDate>(data: T[], timeZone: Timezone | undefined, now: Date): T[] {
  return sortByDrawingDateDesc(data.filter(({ drawingDate }) => isSameDay(new Date(drawingDate), now, timeZone)));
}

export { filterHugeJackpots, filterOneOrLess, filterTodaysDraws };
